export const ErrorType = {
  jsError: 'jsError',
  resourceError: 'resourceError',
  ajaxError: 'ajaxError',
  customError: 'customError'
};
export const ErrorLevel = {
  info: 'info',
  debug: 'debug',
  error: 'error',
  warn: 'warn'
};
